import { render, staticRenderFns } from "./FillLogisticsInfo.vue?vue&type=template&id=0f494cac&scoped=true"
import script from "./FillLogisticsInfo.vue?vue&type=script&lang=js"
export * from "./FillLogisticsInfo.vue?vue&type=script&lang=js"
import style0 from "./FillLogisticsInfo.vue?vue&type=style&index=0&id=0f494cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f494cac",
  null
  
)

export default component.exports